<section class="dry-run">
    <h3 class="dry-run__title">{{ title$$() }}</h3>
    <p class="dry-run__info">{{ info$$() }}</p>

    <div class="dry-run__filters">
        <app-select-control [control]="control_period" [label]="_text.period" [list]="list_period" [compareWith]="compareWith" />
    </div>

    @if (result$$(); as result) {
        @if (!result[billingDryRunDto.billable]) {
            <p class="dry-run__notice">{{ _text.notBillable }}</p>
        }
        @if (result[billingDryRunDto.currentMonth]) {
            <p class="dry-run__info">{{ _text.current }}</p>
        }

        @if ((result[billingDryRunDto.lines] ?? []).length === 0) {
            <p class="dry-run__info">{{ _text.empty }}</p>
        } @else {
            <div class="dry-run__table">
                <span class="dry-run__head">{{ _text.kind }}</span>
                <span class="dry-run__head">{{ _text.user }}</span>
                <span class="dry-run__head">{{ _text.function }}</span>
                <span class="dry-run__head dry-run__num">{{ _text.days }}</span>
                <span class="dry-run__head dry-run__num">{{ _text.blocks }}</span>
                <span class="dry-run__head dry-run__num">{{ _text.credits }}</span>
                <span class="dry-run__head">{{ _text.note }}</span>
                @for (line of result[billingDryRunDto.lines] ?? []; track $index) {
                    <span>{{ kind_label(line[billingDryRunLineDto.kind]) }}</span>
                    <span>{{ line[billingDryRunLineDto.userName] }}</span>
                    <span>{{ line[billingDryRunLineDto.functionName] }}</span>
                    <span class="dry-run__num">{{ line[billingDryRunLineDto.days] || '' }}</span>
                    <span class="dry-run__num">{{ line[billingDryRunLineDto.blocks] || '' }}</span>
                    <span class="dry-run__num">{{ number_format(line[billingDryRunLineDto.credits]) }}</span>
                    <span class="dry-run__note">{{ line[billingDryRunLineDto.note] }}</span>
                }
                <span class="dry-run__total">{{ _text.total }} {{ periodLabel$$() }}</span>
                <span class="dry-run__num dry-run__total-value">{{ number_format(result[billingDryRunDto.total]) }}</span>
                <span></span>
            </div>
        }

        <p class="dry-run__subtitle">{{ _text.storage }}</p>
        @if (storage$$().length === 0) {
            <p class="dry-run__info">{{ _text.noStorage }}</p>
        } @else {
            <div class="dry-run__storage">
                @for (usage of storage$$(); track usage[billingStorageUsageDto.day]) {
                    <span [class.dry-run__peak]="usage[billingStorageUsageDto.bytes] === storagePeak$$()">
                        {{ usage[billingStorageUsageDto.day] | appDate:'date':false }}: {{ bytes_format(usage[billingStorageUsageDto.bytes]) }}
                    </span>
                }
            </div>
        }

        @if (result[billingDryRunDto.charged] != null) {
            <p class="dry-run__info">{{ _text.charged }}: {{ number_format(result[billingDryRunDto.charged]) }}</p>
        }
    } @else if (loading$$()) {
        <p class="dry-run__info">{{ _text.loading }}</p>
    }
</section>
